import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="job-announcement-form"
export default class extends Controller {
  static targets = ["selectAll", "selectedText"]
  static values = {
    usersCount: Number
  }
  
  updateSelectedText(e) {
    let selectedCount = this.element.querySelectorAll('input[type="checkbox"]:checked').length;
    if (this.selectAllTarget.checked) {
      selectedCount = selectedCount - 1;
    }
    const event = new CustomEvent("users-selected", { "detail": { "original_target": e.target } });
    this.element.closest("form").dispatchEvent(event);

    this.selectedTextTarget.textContent = `(${selectedCount} selected)`;
  }

  maybeSelectAll() {
    if (this.selectAllTarget.checked) {
      this.selectAll();
    }
  }

  selectAll() {
    if (this.selectAllTarget.checked) {
      this.element.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        checkbox.checked = true;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      });
      this.selectedTextTarget.textContent = `(${this.usersCountValue} selected)`;
    } else {
      this.element.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        checkbox.checked = false;
      });
      this.selectedTextTarget.textContent = `(0 selected)`;
    }
  }
}
